import React from 'react';
interface QuoteProps {
  children: React.ReactNode;
}
export function Quote({
  children
}: QuoteProps) {
  return <blockquote className="my-2 md:my-3 bg-[#F3F4F6] rounded-lg px-6 py-5 md:px-8 md:py-6 text-[1.05rem] md:text-[clamp(1.05rem,1.5vw,1.333rem)] text-[#7A8290] italic leading-relaxed animate-fadeIn" data-id="element-239">
      "{children}"
    </blockquote>;
}